<template>
    <transition name="slide-up">
        <div v-if="content && open" class="modal content-dimensioning">
            <span v-if="$listeners && $listeners.close" class="modal__close-button" @click="close">
                <svgicon name="close-big" />
            </span>
            <div class="modal__page-container">
                <div class="modal__content-container">
                    <div class="modal__grid">
                        <div class="modal__grid-column modal__grid-column--text">
                            <introtext-element v-if="content.introtext" :introtext="content.introtext"></introtext-element>
                        </div>

                        <div v-if="content.media && (content.media.image || content.media.video)" class="modal__grid-column modal__grid-column--media">
                            <media-element :media="content.media"></media-element>
                        </div>

                        <div v-if="$slots.component" class="modal__grid-column modal__grid-column--component">
                            <slot name="component" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>

export default {
    name: 'ModalElement',
    props: {
        content: Object,
        open: Boolean,
    },

    watch: {
        open(newValue, oldValue) {

            if (newValue == false) {
                document.documentElement.classList.remove('scroll-lock');
            } else {
                document.documentElement.classList.add('scroll-lock');
            }
        },
    },

    created() {
        document.addEventListener('keydown', this.handleKeyDown);
    },
    methods: {
        close() {
            this.$emit('close');
        },
        handleKeyDown(event) {
            if (this.open && event.keyCode == 27) {
                this.close();
            }
        }
    },
    beforeDestroy() {
        document.documentElement.classList.remove('scroll-lock');
        document.removeEventListener('keydown', this.handleKeyDown);
    }
}
</script>
